import { useState } from "react"
import { useFormikContext } from "formik"
import { makeStyles } from "tss-react/mui"
import { Alert, AlertColor, AlertTitle, Box, Stack } from "@mui/material"
import { ConfigQuery, fetchMeetingServiceMessages, MeetingServiceMessagesResponse } from "../../../createOrderApi"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { StandardButton } from "../../../../buttons/StandardButton"
import { SelectedPriceListItem } from "../../../createOrderTypes"
import { MeetingServiceTabValues } from "../../form/formTypes"
import { getTopPriorityMessage } from "./helpers"
import { MessagesDialog } from "./MessagesDialog"

const useStyles = makeStyles()((_theme) => ({
    container: {
        padding: ".5rem 0",
    },
    text: {
        display: "-webkit-box",
        WebkitLineClamp: 3,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: ".875rem",
    },
    button: {
        padding: 0,
        "&:hover": {
            background: "transparent",
        },
    },
}))

const selectBookingConfig = (data: MeetingServiceMessagesResponse) => data?.messages || []

export function Messages() {
    const { classes } = useStyles()

    const { values } = useFormikContext<MeetingServiceTabValues>()
    const priceListItem: SelectedPriceListItem = values["priceList"]

    const { data: messages = [] } = useApiQuery(fetchMeetingServiceMessages, {
        queryName: ConfigQuery.MEETING_SERVICE_MESSAGES,
        dependencies: {
            merchantId: priceListItem.merchantId,
            priceListId: priceListItem.priceListId,
            shopId: priceListItem.shopId,
        },
        select: selectBookingConfig,
        enabled: !!priceListItem.merchantId && !!priceListItem.priceListId && !!priceListItem.shopId,
    })

    const [openModal, setOpenModal] = useState(false)
    const topPriorityMessage = getTopPriorityMessage(messages)

    const handleReadMore = () => setOpenModal(true)
    const handleClose = () => setOpenModal(false)

    return !!messages.length ? (
        <>
            {topPriorityMessage && (
                <Stack gap=".5rem" className={classes.container}>
                    <Alert severity={topPriorityMessage.severity.toLowerCase() as AlertColor}>
                        <AlertTitle className={classes.text}>{topPriorityMessage.title}</AlertTitle>
                    </Alert>

                    <Box>
                        <LocalizedStrict
                            id={
                                messages.length > 1
                                    ? "create-order-drawer-messages-read-more"
                                    : "create-order-drawer-messages-one-message-read-more"
                            }
                            vars={{ cont: messages.length }}
                        >
                            <StandardButton
                                variant="text"
                                onClick={handleReadMore}
                                fullWidth={false}
                                updateDefaultClasses={classes.button}
                            >
                                Read more
                            </StandardButton>
                        </LocalizedStrict>
                    </Box>
                </Stack>
            )}

            {openModal && <MessagesDialog messages={messages} onClose={handleClose} />}
        </>
    ) : (
        <></>
    )
}
